export default __webpack_public_path__ + "static/hero_personal_back_img_1-47d0922610c7734ea00ccd0dc0515eaa.png";